import {Component} from "react";
import {withTranslation} from "react-i18next";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import $ from 'jquery';
import withFormHanlding from "../../hoc/FormHandling";
import lampManage from "../../reducers/lamp-manage";
import LampSettings from "../screens/LampSettings";

class LampSettingsContainer extends Component {
    constructor(props) {
        super(props);

        let formState = {
            formErrors: {
                auto_update: [],
                show_last_hours: [],
                show_intervals: [],
                intervals: [],
                my_intervals: [],
                sort_by: [],
                display_in_control: [],
                display_in_block: [],
                terminal_id: [],
                sort_type: [],
                show_in_card: []
            },
            formValues: {
                auto_update: '',
                show_last_hours: '',
                show_intervals: [],
                intervals: [],
                my_intervals: [],
                sort_by: '',
                display_in_control: '',
                display_in_block: '',
                terminal_id: '',
                sort_type: '',
                show_in_card: '',
                structures: '',
            },
            formValid: false,
            onSubmit: this.onSubmit
        };

        document.title = props.document_title || props.t('Display settings');
        props.prepareFormState(formState);
    }

    componentDidMount() {
        let nodeAutoUpdate = document.getElementById('auto_update');
        let nodeQuickSwitching = document.getElementById('quick_switching');
        let nodeStructures = document.getElementById('structures');
        let nodeTemplate = document.getElementById('template');
        let nodeShowLastHours = document.getElementById('show_last_hours');
        let nodeTerminalId = document.getElementById('terminal_id');
        let nodeShowIntervals = document.getElementById('show_intervals');
        let nodeSortBy = document.getElementById('sort_by');
        let nodeDisplayInControl = document.getElementById('display_in_control');
        let nodeDisplayInBlock = document.getElementById('display_in_block');
        let nodeSortType = document.getElementById('sort_type');
        let nodeShowInCard = document.getElementById('show_in_card');

        this.props.validateField(nodeAutoUpdate);
        this.props.validateField(nodeQuickSwitching);
        this.props.validateField(nodeStructures);
        this.props.validateField(nodeTemplate);
        this.props.validateField(nodeShowLastHours);
        this.props.validateField(nodeTerminalId);
        this.props.validateField(nodeShowIntervals);
        this.props.validateField(nodeSortBy);
        this.props.validateField(nodeDisplayInControl);
        this.props.validateField(nodeDisplayInBlock);
        this.props.validateField(nodeSortType);
        this.props.validateField(nodeShowInCard);
    }

    onChange = (e) => this.props.validateField(e.target);

    onSetTemplateLamp = (type_view = 'grid') => {
        let nodeTemplate = document.getElementById('template');
        nodeTemplate.value = (type_view === 'grid') ? 'grid' : 'list';
        this.props.validateField(nodeTemplate);
    }

    onSetStructure = (structures = []) => {
        let nodeStructure = document.getElementById('structures');
        nodeStructure.value = JSON.stringify(structures.map((id) => +id));
        this.props.validateField(nodeStructure);
    }

    viewToggleClass = (e) => {
        let nodesViewRadio = document.querySelectorAll('.js-view-radio');
        nodesViewRadio.forEach((node) => {
            node.classList.remove('Btn_success');
            node.classList.add('Btn_secondary');
        });
        e.currentTarget.classList.add('Btn_success');
    }

    onSetShowInCard = () => {
        let nodeSelectInCard = $("#select_show_in_card");
        let values = JSON.stringify(nodeSelectInCard.val());
        let nodeInCard = document.getElementById('show_in_card');
        nodeInCard.value = values;
        this.props.validateField(nodeInCard);
    }

    onSetTerminalId = () => {
        let nodeSelectTerminalId= $("#select_terminal_id");
        let values = JSON.stringify(nodeSelectTerminalId.val());
        let nodeTerminalId = document.getElementById('terminal_id');
        nodeTerminalId.value = values;
        this.props.validateField(nodeTerminalId);
    }

    onSetDisplayInControl = () => {
        let nodeSelectDisplayInControl = $("#select_display_in_control");
        let values = JSON.stringify(nodeSelectDisplayInControl.val());
        let nodeDisplayInControl = document.getElementById('display_in_control');
        nodeDisplayInControl.value = values;
        this.props.validateField(nodeDisplayInControl);
    }

    onSetDisplayInBlock = () => {
        let nodeSelectDisplayInBlock = $("#select_display_in_block");
        let values = JSON.stringify(nodeSelectDisplayInBlock.val());
        let nodeDisplayInBlock = document.getElementById('display_in_block');
        nodeDisplayInBlock.value = values;
        this.props.validateField(nodeDisplayInBlock);
    }

    onSetShowIntervals = (event, new_show_intervals) => {
        let nodeSelectShowIntervals = $("#select_show_intervals");
        let values = new_show_intervals || new_show_intervals?.length === 0 ? JSON.stringify(new_show_intervals) : JSON.stringify(nodeSelectShowIntervals.val());
        let nodeShowIntervals = document.getElementById('show_intervals');
        nodeShowIntervals.value = values;
        (new_show_intervals || new_show_intervals?.length === 0) && lampManage.setShowIntervals(new_show_intervals);
        this.props.validateField(nodeShowIntervals);
    }

    setMyIntervals = (my_intervals) => {
        this.props.formValues.my_intervals = JSON.stringify(my_intervals);
        lampManage.setMyIntervals(my_intervals);
    }

    onSubmit = () => {
        let formValues = this.props.formValues;
        if (formValues.show_last_hours < 0) formValues.show_last_hours = 0;
        if (formValues.show_last_hours > 99) formValues.show_last_hours = 99;
        if (!formValues.show_last_hours) formValues.show_last_hours = 9;
        if (!formValues.intervals) formValues.intervals = JSON.stringify(this.props.lamp.view_settings.intervals);
        if (!formValues.my_intervals) formValues.my_intervals = JSON.stringify(this.props.lamp.view_settings.my_intervals);
        lampManage.saveViewSettings(formValues);
        this.props.history.push('/');
    }

    render() {
        return <LampSettings onSetDisplayInControl={this.onSetDisplayInControl}
                        onSetDisplayInBlock={this.onSetDisplayInBlock}
                        onSetShowInCard={this.onSetShowInCard}
                        onSetTerminalId={this.onSetTerminalId}
                        viewToggleClass={this.viewToggleClass}
                        onSetStructure={this.onSetStructure}
                        onSetTemplateLamp={this.onSetTemplateLamp}
                        onSubmit={this.onSubmit}
                        onChange={this.onChange}
                        setMyIntervals={this.setMyIntervals}
                        onSetShowIntervals={this.onSetShowIntervals}
                        {...this.props} {...this.state} />
    }
}

const mapStateToProps = (store) => {
    return {
        document_title: store.appState.document_title,
        lamp: store.lampState,
        theme: store.appState.theme_name,
    };
};

export default withRouter(connect(mapStateToProps)(withTranslation()(withFormHanlding(LampSettingsContainer))));